<template>
   <!-- <router-view/> -->
  <router-view v-slot="{ Component }">
    <transition name="flash" mode="out-in">
      <component :is="Component" />
    </transition>
    <Conversation ref="conversation"/>
    <BottomMenu />
    <Chat/>
  </router-view>
  <!-- Home stays mounted forever, just hidden when off-route -->
  <Home v-show="$route.path === '/home'" ref="home"/>
  <AudioPlayers style="z-index: 3000;" ref="audioPlayers" />
<!--   <GlobalPlayer />   -->
</template>

<style>
/* Simple Flash Transition */
.flash-enter-active,
.flash-leave-active {
  transition: opacity 0.1s ease-in-out;
}
.flash-enter-from {
  opacity: 0;
}
.flash-leave-to {
  opacity: 0;
}

:root {
  --mainColor: rgb(60, 94, 189);
}

html, body {
  background: #0a0e26;
  margin: 0;
  padding: 0;
}
button, article, input {
  outline: none;
}
#app {
font-family:Arial, Helvetica, sans-serif;
-webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;
text-align: center;
color:#37404A;
font-size: 15px;
background: #0a0e26;
min-height: 100vh;
}
#app * {
box-sizing: border-box;
-webkit-tap-highlight-color: transparent;
}

</style>
<script>
import BottomMenu from '@/views/components/bottomMenu/BottomMenu'
import Chat from '@/views/chat/Chat'
import Conversation from '@/views/conversation/Conversation.vue';
/* import GlobalPlayer from '@/views/publications/GlobalPlayer.vue' */
import Home from '@/views/home/Home.vue' 
import AudioPlayers from '@/views/audioPlayers/AudioPlayers.vue'


export default {
  name: 'App',
  components:{
    BottomMenu,
    Chat,
    Conversation,
/*     GlobalPlayer, */
    Home,
    AudioPlayers
  }
  }
</script>